<template>
    <div class="login-fields-container">  
        <div class="field-wrapper" v-if="useUsername">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="login-field" type="text" v-checkenter="login" v-model="username" :placeholder="placeholderUsername ? placeholderUsername : 'NOME'">
        </div>
        <div class="field-wrapper" v-if="useEmail">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="email" v-checkenter="login" v-model="email" :placeholder="placeholderEmail ? placeholderEmail : 'EMAIL'">
        </div>      
        <input class="login-button" type="button" :value="cta ? cta : 'ENTRAR'" @click.prevent="login">
    </div>
</template>

<script>
    import api from '@/services/api';            

    export default {
        name: 'AnonimousLogin',

        props: {
            useUsername: false,
            useEmail: false,
            placeholderUsername: '',
            placeholderEmail: '',            
            cta: ''
        },       
        
        data ()
        {
            return {
                username: '',
                email: ''
            }
        },

        methods: {
            
            async login ()
            {                
                const obj={}
                if (this.username) obj.name = this.username;
                if (this.email) obj.email = this.email;
                api
                    .post(`event/${this.$store.state.eventId}/loginAnon`, obj)
                    .then(response => {
                        this.$emit('logged', response);
                    })
                    .catch(err => {
                        console.log('catch');
                        if (err.response?.data.error.includes('Valid process expected'))
                        {
                            api
                                .post(`event/${this.$store.state.eventId}/retryValidMail`, {
                                    email: this.username,
                                })
                                .then(response => {
                                    this.$emit('error', 'notValidated');
                                })
                                .catch(err => {
                                    this.$emit('error', 'fail');
                                });
                        }
                        else
                        {
                            this.$emit('error', 'fail');
                        }
                    });               
            }
        }
        
    }
</script>

<style lang="scss">
    
</style>